export const QueryKey = {
  Resource: {
    Organization: 'organization',
    OrganizationUsers: 'organization-users',
    OrganizationTasks: 'organization-tasks',
    OrganizationMembers: 'organization-members',
    OrganizationSummary: 'organization-summary',
    OrganizationSummaryActionItems: 'organization-summary-action-items',
    OrganizationEmployees: 'organization-employees',
    OrganizationTeamMembers: 'organization-team-members',
    OrganizationCoworkers: 'organization-coworkers',
    ChildOrganizations: 'child-organizations',
    OrganizationAudits: 'organization-audits',
    OrganizationLocations: 'organization-locations',
    OrganizationAllowedDomains: 'organization-allowed-domains',
    OrganizationAdditionalColumns: 'organization-additional-columns',
    OrganizationOverview: 'organization-overview',
    SubAudits: 'sub-audits',
    SubAuditsComments: 'sub-audits-comments',
    SubAuditHistory: 'sub-audit-history',
    User: 'user',
    UserOrganizations: 'user-organizations',
    UserPreferences: 'user-preferences',
    UserSettings: 'user-settings',
    InvitedUsers: 'invited-users',
    Task: 'task',
    TaskComments: 'task-comments',
    SiteList: 'site-list',
    VectorSiteList: 'vector-site-list',
    SiteListFiles: 'site-list-files',
    Subtask: 'subtask',
    RecurringTask: 'recurring-task',
    ActionItem: 'action-item',
    SpendArea: 'spend-area',
    SavingsSummary: 'savings-summary',
    SpendAreaSavings: 'spend-area-savings',
    AnnualSpendAreaSavings: 'annual-spend-area-savings',
    SpendCategoryNames: 'spend-category-names',
    Documents: 'documents',
    DocumentColumnMaxValues: 'document-column-max-values',
    DocumentTypeSelectList: 'document-type-select-list',
    DocumentSpendCategorySelectList: 'document-spend-category-select-list',
    DocumentVendorSelectList: 'document-vendor-select-list',
    Notifications: 'notifications',
    ExternalUsers: 'external-users',
    Teams: 'teams',
    TeamsSingle: 'teams-single',
    TeamMembers: 'team-members',
    DocumentTags: 'document-tags',
    Tags: 'tags',
    ClientContacts: 'client-contacts',
    VendorContacts: 'vendor-contacts',
    TaskHistory: 'task-history',
    AssignedTasks: 'assigned-tasks',
    Vendors: 'vendors',
    VendorsServiceCategories: 'service-categories',
    VendorsSelectList: 'vendors-select-list',
    PowerBiOrganizationReports: 'power-bi-organization-reports',
    Template: 'template',
    TaskCount: 'task-count',
    Changelogs: 'changelogs',
    Members: 'members',
    Tickets: 'tickets',
    Invoices: 'invoices',
    franzAI: 'franz-ai',
    OrganizationActiveTasks: 'organization-active-tasks',
    OrganizationTickets: 'organization-tickets',
    TicketTypeGroup: 'ticket-type-group',
    TicketStatusGroup: 'ticket-status-group',
    TicketOrganizationGroup: 'ticket-organization-group',
    TicketAssigneeGroup: 'ticket-assignee-group',
    TicketComments: 'ticket-comments',
    TicketFiles: 'ticket-files',
    Faqs: 'faqs',
    VectorContracts: 'vector-contracts',
    VirtualDocuments: 'virtual-documents',
    Projects: 'projects',
    ProjectTickets: 'project-tickets',
    VendorTickets: 'vendor-tickets',
    ProjectFiles: 'project-files',
    InternalPortalOrganizations: 'internal-portal-organizations',
    InternalPortalLocations: 'internal-portal-locations',
    InternalPortalActionItems: 'internal-portal-action-items',
    InternalPortalVendors: 'internal-portal-vendors',
    InternalPortalContacts: 'internal-portal-contacts',
    SidecarDocumentBulkEditVendor: 'sidecar-document-bulk-edit-vendor',
    BlobHealthCheck: 'blob-health-check',
    OrganizationMainPointOfContact: 'organization-main-point-of-contact',
    InternalPortalVendorSpendCategories:
      'internal-portal-vendor-spend-categories',
    VendorsImportTemplate: 'vendors-import-template',
  },
  Operation: {
    List: 'list',
    One: 'one',
    Infinite: 'infinite',
    Count: 'count',
  },
};

export { HttpStatusCode } from 'axios';

export enum MutationKey {}

export enum StoragePrefix {
  Document = 'document',
  OrganizationLogo = 'organization-logo',
  ProfilePicture = 'profile-picture',
  Zip = 'zip',
}

export enum BillingContactProvider {
  Vector = 'Vector',
  Sib = 'Sib',
}
